import styled from 'styled-components';

export const IframeContainerStyled = styled.div`
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
`;
